import { useMediaQuery } from '@mui/material';

export default function useDesktopDeviceMediaQuery() {
  // Check if endpoint is a desktop device, we had no media fort his
  const isDeviceQuery = useMediaQuery(` (min-width: ${1200}px) `);
  return isDeviceQuery;
}
